export const formatWebhookEvent = (data) => {
  if (data === 'request_inspection') return 'Vistoria solicitada';
  if (data === 'request_complementar') return 'Vistoria complementar solicitada';
  if (data === 'cancel_inspection') return 'Vistoria cancelada';
  if (data === 'start_inspection') return 'Vistoria iniciada';
  if (data === 'finish_inspection') return 'Vistoria finalizada';
  if (data === 'approve_inspection') return 'Vistoria aprovada';
  if (data === 'reject_inspection') return 'Vistoria rejeitada';
};
